import React, { Suspense } from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import Team from "../assets/img/custom/team.jpg";
import routes from "routes.js";

const Auth = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div ref={mainContent}>
        <Container fluid>
          <Row className="auth-right">
            <Col lg={5} className="bg-white-1">
              <Suspense fallback={<div className="text-center mt-5">Loading…</div>}>
                <Switch>
                  {getRoutes(routes)}
                  <Redirect from="*" to="/auth/login" />
                </Switch>
              </Suspense>
            </Col>
            <Col lg={7} className="bg-secondary">
              <div>
                <h2 className="text-dark  auth-desc-title">
                  HOW FANS HELP PLAYERS
                </h2>
                <p className="text-dark auth-desc-subtitle">
                  We all love our favorite School Teams - but some players
                  STRUGGLE Just to pay their bills. Now we FANS can help. LAWS
                  for ATHLETE NIL (Name, Image, Likeness) allow Athletes to
                  Serve here as BRAND AMBASSADORS. FANS can buy online goods
                  from them or pay to attend their chats. That way Our Favorite
                  athletes more easily pay bills, then Re-focus on Studies and
                  Sports. One possibility is to buy an ENDORSEMENT BADGE.
                  Here are the steps:
                </p>
                <p className="text-dark auth-desc-points">
                  1- Players all get signed up right here. And Fans, we each
                  find our favorite player by searching.
                  <br />
                  <br />
                  2- An Endorsement badge with <u> Price as fan chooses</u> - $4
                  to $599 , depending on duration of license user selects. .
                  <br />
                  <br />
                  3- Fan downloads their endorsement badge and posts it on their
                  social media page.
                  <br />
                  <br />
                  4- Buyer on honor system to remove badge from social media
                  after license expires.
                  <br />
                  <br />
                  5- Each dollar of price gives one week on license. Example,
                  price of $4 means license expires after 4 weeks from purchase
                  and display.
                  <br />
                  <br />
                  6. Athletes also make other types of Fan Interaction available
                  here at FHP. Fans can choose Seasonal Badges or Video Views,
                  Talking Badges, Chats with Athletes or Mementos. Plus, lots
                  more. Time to SIGN UP & DIG IN!
                  <br />
                  <br />
                  7. The red text indicates that the checkbox is pending without
                  this check you will not be able to SignUp!
                </p>
                <div className="text-center mb-3 d-none d-sm-block">
                  <Row className="justify-content-center">
                    <Col md="8">
                      <img src={Team} alt="balls" width="100%" />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Auth;
